import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TS_Icons } from '@nu-art/ts-styles';
import { _keys, deepClone, exists } from '@nu-art/ts-common';
import { Component_SearchAddOn } from '@nu-art/search';
import { SearchAddOn_PathwayStatus } from './types.js';
import { LL_H_C, LL_V_L, TS_CheckboxV2, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './SearchAddOn_PathwayStatus.scss';
import { Dropdown_PathwayType } from '../../../_entity.js';
import { PathwayTypeToLabel } from '@app/pathway-shared';
import { ICONS } from '@app/styles';
export class Component_SearchAddOn_PathwayStatus extends Component_SearchAddOn {
    addOn = SearchAddOn_PathwayStatus;
    //######################### Logic #########################
    toggleStatus = (statusKey) => {
        const value = exists(this.state.value) ? { ...this.state.value } : {};
        const current = value[statusKey];
        switch (current) {
            case true:
                value[statusKey] = undefined;
                break;
            case false:
                value[statusKey] = true;
                break;
            default:
                value[statusKey] = false;
                break;
        }
        this.setValue(value);
    };
    pathwayType = {
        add: (type) => {
            const value = exists(this.state.value) ? deepClone(this.state.value) : {};
            if (!value.types)
                value.types = {};
            if (value.types[type])
                return;
            value.types[type] = true;
            this.setValue(value);
        },
        remove: (type) => {
            if (!this.state.value?.types?.[type])
                return;
            const value = deepClone(this.state.value);
            delete value.types[type];
            if (!_keys(value.types).length)
                delete value.types;
            this.setValue(value);
        }
    };
    //######################### Render #########################
    render() {
        return _jsx(TS_PropRenderer.Vertical, { label: this.render_Label, className: 'search-add-on__pathway-status', children: _jsxs(LL_V_L, { children: [_jsxs(LL_H_C, { className: 'search-add-on__row', children: [_jsx(TS_CheckboxV2, { label: 'Is Archived', checked: this.state.value?.isArchived, onCheck: () => this.toggleStatus('isArchived') }), _jsx(TS_CheckboxV2, { label: 'Is Under Construction', checked: this.state.value?.isUnderConstruction, onCheck: () => this.toggleStatus('isUnderConstruction') })] }), _jsx(LL_H_C, { className: 'search-add-on__row', children: this.render_PathwayTypes() })] }) });
    }
    render_PathwayTypes = () => {
        const types = _keys(this.state.value?.types ?? {});
        return _jsx(TS_PropRenderer.Vertical, { label: 'Pathway Type', children: _jsxs(LL_H_C, { className: 'pathway-type-multi-select', children: [types.map(type => {
                        return _jsxs(LL_H_C, { className: 'pathway-type-multi-select-option', children: [_jsx(ICONS.x.component, { onClick: () => this.pathwayType.remove(type) }), PathwayTypeToLabel[type]] }, type);
                    }), _jsx(Dropdown_PathwayType.selectable, { selected: undefined, onSelected: item => this.pathwayType.add(item), queryFilter: item => !this.state.value?.types?.[item] })] }) });
    };
    render_Label = () => {
        return _jsxs(_Fragment, { children: ["By Pathway Status", _jsx(TS_Icons.clear.component, { onClick: this.clear })] });
    };
}
//# sourceMappingURL=SearchAddOn_PathwayStatus.js.map